<template>
  <div>
    <v-data-table
      :items="agreementUsers"
      :headers="documentAgreementUsersHeaders"
      :items-per-page="-1"
      color="transparent">
      <template #[`item.user`]="{ item }">
        {{ getPersonName(item.user, { initials: true }) }}
      </template>
      <template #[`item.isAgreed`]="{ item }">
        <div class="font-weight-bold">
          <span v-if="item.isAgreed" class="text-success"> Погодив </span>
          <span v-else class="text-grey-darken-1"> Очікується погодження </span>
        </div>
      </template>
      <template #item.agreementDate="{ item }">
        {{
          new CustomDate(item.agreementDate).toString({
            time: true,
          })
        }}
      </template>
      <template #bottom></template>
    </v-data-table>
  </div>
</template>

<script lang="ts">
import { PropType, ref, Ref } from 'vue'
import { Dialog } from '@/dialog'
import { documentAgreementUsersHeaders } from '@/utils/tableHeaders'
import { CustomDate, getPersonName } from 'best-modules/utils'

export default {
  name: 'DocumentAgreementUsers',
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  data() {
    return { documentAgreementUsersHeaders }
  },
  methods: { getPersonName, CustomDate },
  setup(props) {
    const agreementUsers: Ref<any[]> = ref(
      props.dialog.dialogData.participants || []
    )

    return { agreementUsers }
  },
}
</script>
